import { render, staticRenderFns } from "./Regcode.vue?vue&type=template&id=90f6e522&"
import script from "./Regcode.vue?vue&type=script&lang=js&"
export * from "./Regcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports